<template>
  <div>
    <MemberShipBanner
      :imageList="this.config.banner_top.imageList"
    ></MemberShipBanner>
    <MemberShipTitle></MemberShipTitle>
    <MemberShipBannerContent></MemberShipBannerContent>
    <MemberShipRight></MemberShipRight>
    <MemberShipBanner2></MemberShipBanner2>
    <MemberShipCard></MemberShipCard>
    <MemberShipOpeningMethod></MemberShipOpeningMethod>
    <MemberShipIntroduction></MemberShipIntroduction>
    <!-- <MemberShipBenefits></MemberShipBenefits> -->
    <MemberShipComparison></MemberShipComparison>
    <MemberShipBrand></MemberShipBrand>
    <MemberShipBanner3></MemberShipBanner3>
  </div>
</template>

<script>
import MemberShipBanner from "@/yintai/view/content/memberShip/MemberShipBanner.vue";
import MemberShipTitle from "@/yintai/view/content/memberShip/MemberShipTitle.vue";
import MemberShipBannerContent from "@/yintai/view/content/memberShip/MemberShipBannerContent.vue";
import MemberShipRight from "@/yintai/view/content/memberShip/MemberShipRight.vue";
import MemberShipCard from "@/yintai/view/content/memberShip/MemberShipCard.vue";
import MemberShipOpeningMethod from "@/yintai/view/content/memberShip/MemberShipOpeningMethod.vue";
import MemberShipIntroduction from "@/yintai/view/content/memberShip/MemberShipIntroduction.vue";

// import MemberShipBenefits from "@/yintai/view/content/memberShip/MemberShipBenefits.vue";
import MemberShipComparison from "@/yintai/view/content/memberShip/MemberShipComparison.vue";
import MemberShipBrand from "@/yintai/view/content/memberShip/MemberShipBrand.vue";
import MemberShipBanner2 from "@/yintai/view/content/memberShip/MemberShipBanner2.vue";
import MemberShipBanner3 from "@/yintai/view/content/memberShip/MemberShipBanner3.vue";

import { fetchConfig } from "@/yintai/api/config";

export default {
  name: "memberShip",
  components: {
    MemberShipBanner,
    MemberShipTitle,
    MemberShipCard,
    MemberShipOpeningMethod,
    MemberShipIntroduction,
    MemberShipBannerContent,
    MemberShipRight,
    // MemberShipBenefits,
    MemberShipComparison,
    MemberShipBrand,
    MemberShipBanner2,
    MemberShipBanner3,
  },
  data() {
    return {
      config: {
        banner_top: {
          imageList: [],
        },
      },
    };
  },
  async mounted() {
    const response = await fetchConfig({ id: 11 });
    this.config = response.data.data.item.config;
  },
  methods: {},
};
</script>
